import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PhotoUploaderModule } from '@classifieds-sell/trademe-core-ui';
import { TgGridModule } from '@trademe/tangram';
import { PropertyPhotoSectionComponent } from './property-photo-section.component';

@NgModule({
    imports: [CommonModule, FormsModule, TgGridModule, PhotoUploaderModule],
    declarations: [PropertyPhotoSectionComponent],
    exports: [PropertyPhotoSectionComponent]
})
export class PropertyPhotoSectionModule {}
